// extracted by mini-css-extract-plugin
module.exports = {"general-container":"breadcrumb_general-container__x9AHN","partner-logo":"breadcrumb_partner-logo__g4ee8","breadcrumb":"breadcrumb_breadcrumb__v_fMw"};